import {createAsyncThunk, createSlice,} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getJamKerja = createAsyncThunk(
    "jamKerja/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getSetupJamKerja',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const insertJamKerja = createAsyncThunk(
    "jamKerja/insert",
    async ({namaJamKerja, waktuKerja}, thunkAPI) => {
        let formData = new FormData();
        formData.append("namaJamKerja", namaJamKerja);
        formData.append("waktuKerja", waktuKerja);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'insertSetupJamKerja',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const updateJamKerja = createAsyncThunk(
    "jamKerja/update",
    async ({setupJamKerjaID, namaJamKerja, waktuKerja, status}, thunkAPI) => {
        let formData = new FormData();
        formData.append("setupJamKerjaID", setupJamKerjaID);
        formData.append("namaSetupJamKerja", namaJamKerja);
        formData.append("waktuKerja", waktuKerja);
        formData.append("status", status);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'updateSetupJamKerja',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

const initialState = {
    message: "",
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
};

export const jamKerjaSlice = createSlice({
    name: "jamKerja",
    initialState,
    reducers: {},
    extraReducers: {
        [getJamKerja.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getJamKerja.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getJamKerja.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertJamKerja.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertJamKerja.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertJamKerja.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateJamKerja.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateJamKerja.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateJamKerja.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});


export const jamKerjaSelector = (state) => state.jamKerja;
